import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=04a33120&"
import script from "./Validate.vue?vue&type=script&lang=js&"
export * from "./Validate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports